// source: invite.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var elixirpb_pb = require('./elixirpb_pb.js');
goog.object.extend(proto, elixirpb_pb);
goog.exportSymbol('proto.invite.InviteMetadata', null, global);
goog.exportSymbol('proto.invite.InviteMetadata.InviteType', null, global);
goog.exportSymbol('proto.invite.InviteMetadata.MetadataCase', null, global);
goog.exportSymbol('proto.invite.MailInviteMetadata', null, global);
goog.exportSymbol('proto.invite.ShareInviteMetadata', null, global);
goog.exportSymbol('proto.invite.ShareInviteMetadata.ShareType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.invite.InviteMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.invite.InviteMetadata.oneofGroups_);
};
goog.inherits(proto.invite.InviteMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.invite.InviteMetadata.displayName = 'proto.invite.InviteMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.invite.MailInviteMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.invite.MailInviteMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.invite.MailInviteMetadata.displayName = 'proto.invite.MailInviteMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.invite.ShareInviteMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.invite.ShareInviteMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.invite.ShareInviteMetadata.displayName = 'proto.invite.ShareInviteMetadata';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.invite.InviteMetadata.oneofGroups_ = [[3,4]];

/**
 * @enum {number}
 */
proto.invite.InviteMetadata.MetadataCase = {
  METADATA_NOT_SET: 0,
  MAIL_METADATA: 3,
  SHARE_METDATA: 4
};

/**
 * @return {proto.invite.InviteMetadata.MetadataCase}
 */
proto.invite.InviteMetadata.prototype.getMetadataCase = function() {
  return /** @type {proto.invite.InviteMetadata.MetadataCase} */(jspb.Message.computeOneofCase(this, proto.invite.InviteMetadata.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.invite.InviteMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.invite.InviteMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.invite.InviteMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.invite.InviteMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
    invitee: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    inviteType: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    mailMetadata: (f = msg.getMailMetadata()) && proto.invite.MailInviteMetadata.toObject(includeInstance, f),
    shareMetdata: (f = msg.getShareMetdata()) && proto.invite.ShareInviteMetadata.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.invite.InviteMetadata}
 */
proto.invite.InviteMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.invite.InviteMetadata;
  return proto.invite.InviteMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.invite.InviteMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.invite.InviteMetadata}
 */
proto.invite.InviteMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvitee(value);
      break;
    case 2:
      var value = /** @type {!proto.invite.InviteMetadata.InviteType} */ (reader.readEnum());
      msg.setInviteType(value);
      break;
    case 3:
      var value = new proto.invite.MailInviteMetadata;
      reader.readMessage(value,proto.invite.MailInviteMetadata.deserializeBinaryFromReader);
      msg.setMailMetadata(value);
      break;
    case 4:
      var value = new proto.invite.ShareInviteMetadata;
      reader.readMessage(value,proto.invite.ShareInviteMetadata.deserializeBinaryFromReader);
      msg.setShareMetdata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.invite.InviteMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.invite.InviteMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.invite.InviteMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.invite.InviteMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {!proto.invite.InviteMetadata.InviteType} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getMailMetadata();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.invite.MailInviteMetadata.serializeBinaryToWriter
    );
  }
  f = message.getShareMetdata();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.invite.ShareInviteMetadata.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.invite.InviteMetadata.InviteType = {
  MAIL: 0,
  SHARE: 1
};

/**
 * optional string invitee = 1;
 * @return {string}
 */
proto.invite.InviteMetadata.prototype.getInvitee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.invite.InviteMetadata} returns this
 */
proto.invite.InviteMetadata.prototype.setInvitee = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.invite.InviteMetadata} returns this
 */
proto.invite.InviteMetadata.prototype.clearInvitee = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.invite.InviteMetadata.prototype.hasInvitee = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional InviteType invite_type = 2;
 * @return {!proto.invite.InviteMetadata.InviteType}
 */
proto.invite.InviteMetadata.prototype.getInviteType = function() {
  return /** @type {!proto.invite.InviteMetadata.InviteType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.invite.InviteMetadata.InviteType} value
 * @return {!proto.invite.InviteMetadata} returns this
 */
proto.invite.InviteMetadata.prototype.setInviteType = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.invite.InviteMetadata} returns this
 */
proto.invite.InviteMetadata.prototype.clearInviteType = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.invite.InviteMetadata.prototype.hasInviteType = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional MailInviteMetadata mail_metadata = 3;
 * @return {?proto.invite.MailInviteMetadata}
 */
proto.invite.InviteMetadata.prototype.getMailMetadata = function() {
  return /** @type{?proto.invite.MailInviteMetadata} */ (
    jspb.Message.getWrapperField(this, proto.invite.MailInviteMetadata, 3));
};


/**
 * @param {?proto.invite.MailInviteMetadata|undefined} value
 * @return {!proto.invite.InviteMetadata} returns this
*/
proto.invite.InviteMetadata.prototype.setMailMetadata = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.invite.InviteMetadata.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.invite.InviteMetadata} returns this
 */
proto.invite.InviteMetadata.prototype.clearMailMetadata = function() {
  return this.setMailMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.invite.InviteMetadata.prototype.hasMailMetadata = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ShareInviteMetadata share_metdata = 4;
 * @return {?proto.invite.ShareInviteMetadata}
 */
proto.invite.InviteMetadata.prototype.getShareMetdata = function() {
  return /** @type{?proto.invite.ShareInviteMetadata} */ (
    jspb.Message.getWrapperField(this, proto.invite.ShareInviteMetadata, 4));
};


/**
 * @param {?proto.invite.ShareInviteMetadata|undefined} value
 * @return {!proto.invite.InviteMetadata} returns this
*/
proto.invite.InviteMetadata.prototype.setShareMetdata = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.invite.InviteMetadata.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.invite.InviteMetadata} returns this
 */
proto.invite.InviteMetadata.prototype.clearShareMetdata = function() {
  return this.setShareMetdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.invite.InviteMetadata.prototype.hasShareMetdata = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.invite.MailInviteMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.invite.MailInviteMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.invite.MailInviteMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.invite.MailInviteMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
    messageId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.invite.MailInviteMetadata}
 */
proto.invite.MailInviteMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.invite.MailInviteMetadata;
  return proto.invite.MailInviteMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.invite.MailInviteMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.invite.MailInviteMetadata}
 */
proto.invite.MailInviteMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessageId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.invite.MailInviteMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.invite.MailInviteMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.invite.MailInviteMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.invite.MailInviteMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string message_id = 1;
 * @return {string}
 */
proto.invite.MailInviteMetadata.prototype.getMessageId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.invite.MailInviteMetadata} returns this
 */
proto.invite.MailInviteMetadata.prototype.setMessageId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.invite.MailInviteMetadata} returns this
 */
proto.invite.MailInviteMetadata.prototype.clearMessageId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.invite.MailInviteMetadata.prototype.hasMessageId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.invite.ShareInviteMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.invite.ShareInviteMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.invite.ShareInviteMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.invite.ShareInviteMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
    collectionId: msg.getCollectionId_asB64(),
    aclNodeId: msg.getAclNodeId_asB64(),
    shareType: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    expiration: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.invite.ShareInviteMetadata}
 */
proto.invite.ShareInviteMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.invite.ShareInviteMetadata;
  return proto.invite.ShareInviteMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.invite.ShareInviteMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.invite.ShareInviteMetadata}
 */
proto.invite.ShareInviteMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCollectionId(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setAclNodeId(value);
      break;
    case 3:
      var value = /** @type {!proto.invite.ShareInviteMetadata.ShareType} */ (reader.readEnum());
      msg.setShareType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpiration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.invite.ShareInviteMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.invite.ShareInviteMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.invite.ShareInviteMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.invite.ShareInviteMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = /** @type {!proto.invite.ShareInviteMetadata.ShareType} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.invite.ShareInviteMetadata.ShareType = {
  EDIT_AND_SHARE: 0,
  EDIT: 1,
  READ_ONLY: 2,
  VIEW_ONLY: 3
};

/**
 * optional bytes collection_id = 1;
 * @return {!(string|Uint8Array)}
 */
proto.invite.ShareInviteMetadata.prototype.getCollectionId = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes collection_id = 1;
 * This is a type-conversion wrapper around `getCollectionId()`
 * @return {string}
 */
proto.invite.ShareInviteMetadata.prototype.getCollectionId_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCollectionId()));
};


/**
 * optional bytes collection_id = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCollectionId()`
 * @return {!Uint8Array}
 */
proto.invite.ShareInviteMetadata.prototype.getCollectionId_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCollectionId()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.invite.ShareInviteMetadata} returns this
 */
proto.invite.ShareInviteMetadata.prototype.setCollectionId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.invite.ShareInviteMetadata} returns this
 */
proto.invite.ShareInviteMetadata.prototype.clearCollectionId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.invite.ShareInviteMetadata.prototype.hasCollectionId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes acl_node_id = 2;
 * @return {!(string|Uint8Array)}
 */
proto.invite.ShareInviteMetadata.prototype.getAclNodeId = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes acl_node_id = 2;
 * This is a type-conversion wrapper around `getAclNodeId()`
 * @return {string}
 */
proto.invite.ShareInviteMetadata.prototype.getAclNodeId_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getAclNodeId()));
};


/**
 * optional bytes acl_node_id = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAclNodeId()`
 * @return {!Uint8Array}
 */
proto.invite.ShareInviteMetadata.prototype.getAclNodeId_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getAclNodeId()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.invite.ShareInviteMetadata} returns this
 */
proto.invite.ShareInviteMetadata.prototype.setAclNodeId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.invite.ShareInviteMetadata} returns this
 */
proto.invite.ShareInviteMetadata.prototype.clearAclNodeId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.invite.ShareInviteMetadata.prototype.hasAclNodeId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ShareType share_type = 3;
 * @return {!proto.invite.ShareInviteMetadata.ShareType}
 */
proto.invite.ShareInviteMetadata.prototype.getShareType = function() {
  return /** @type {!proto.invite.ShareInviteMetadata.ShareType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.invite.ShareInviteMetadata.ShareType} value
 * @return {!proto.invite.ShareInviteMetadata} returns this
 */
proto.invite.ShareInviteMetadata.prototype.setShareType = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.invite.ShareInviteMetadata} returns this
 */
proto.invite.ShareInviteMetadata.prototype.clearShareType = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.invite.ShareInviteMetadata.prototype.hasShareType = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string expiration = 4;
 * @return {string}
 */
proto.invite.ShareInviteMetadata.prototype.getExpiration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.invite.ShareInviteMetadata} returns this
 */
proto.invite.ShareInviteMetadata.prototype.setExpiration = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.invite.ShareInviteMetadata} returns this
 */
proto.invite.ShareInviteMetadata.prototype.clearExpiration = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.invite.ShareInviteMetadata.prototype.hasExpiration = function() {
  return jspb.Message.getField(this, 4) != null;
};


goog.object.extend(exports, proto.invite);
